import React from "react"

const AuthLayoutTitle = ({ title }) => {
    return (
        <p className="font-semibold tracking-wide !text-white text-lg lg:text-xl text-center leading-8">
            {title}
        </p>
    )
}

export default AuthLayoutTitle
